export enum AttributeInputType {
  DROPDOWN,
  INPUT,
  RANGE
}
